import React, { useEffect, useCallback, useState} from 'react';
import {setParameterSliderDown} from "actions/index.js";
import TrackMeter from 'components/TrackMeter.js';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import {connect} from 'react-redux';

const VolumeSlider = ({track, volume, setVolume, setParameterSliderDown}) => { 
    const onMouseUp = useCallback(() => {
        setParameterSliderDown(undefined);
        if (!track) {
            return;
        }
        let parameter = track.volumeParameter;
        if (parameter) {
            parameter.automation.smoothen();
            parameter.mixAutomation.smoothen();
        }
    }, [track]);

    const onChangeVolume = useCallback((val) => {
        let vol = getVolumeFromRatio(val);
        setVolume(vol);
    }, [setVolume, track]);

    return (
        <div
          onMouseDown={() => setParameterSliderDown(track && track.volumeParameter)}
          onMouseUp={onMouseUp} className="mix-volume-slider">
          <ReactBootstrapSlider
            handle="square"
            value={Math.pow(getVolumeRatio(volume), 2)}
            change={(e) => onChangeVolume(e.target.value)}
            step={0.01}
            max={1}
            min={0}
            orientation="vertical"
            reversed={true}
          /> 
        {track ? <TrackMeter meter={track.trackMeter}/> : ''}
        </div>);
}

function getVolumeFromRatio(ratio, min=-60, max=2, width) {
    let fullRatio = Math.pow(ratio, 0.5);
    return min + (max - min) * fullRatio;
}

function getVolumeRatio(volume, min=-60, max=2) {
    return (volume - min) / (max - min);
}


const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
        setParameterSliderDown: parameter => dispatch(setParameterSliderDown(parameter)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VolumeSlider);
